import { render, staticRenderFns } from "./integrations-page.vue?vue&type=template&id=76aa85c6&scoped=true&"
import script from "./integrations-page.vue?vue&type=script&lang=js&"
export * from "./integrations-page.vue?vue&type=script&lang=js&"
import style0 from "./integrations-page.vue?vue&type=style&index=0&id=76aa85c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa85c6",
  null
  
)

export default component.exports